module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Izvešaj kompanije")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "form-label"
  }, [_vm._v("Od: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Od: ",
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "change": _vm.changedDateFrom,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label"
  }, [_vm._v("Do: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Do: ",
      "name": "email"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "change": _vm.changedDateTo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "#2b542c",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.getReport()
      }
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v("  Zatraži izveštaj\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "90%",
      "border-radius": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pretraga",
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', _vm._l((_vm.dispatchersCount.filter(function (e) { return e.count > 0; })), function(item) {
    return _c('span', {
      staticStyle: {
        "color": "cornflowerblue"
      }
    }, [_c('b', [_vm._v("[ " + _vm._s(item.name) + " - "), _c('i', {
      staticStyle: {
        "color": "#FFF"
      }
    }, [_vm._v(_vm._s(item.count))]), _vm._v(" ]")]), _vm._v("   \n              ")])
  }), 0), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsers), function(obj, index) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.filteredUsers.length - index) + ".")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(obj.name))]), _vm._v(" "), (obj.count > 0) ? _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(obj.count))]) : _vm._e(), _vm._v(" "), (obj.count <= 0) ? _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white",
        "background": "#dd3333"
      }
    }, [_vm._v(_vm._s(obj.count))]) : _vm._e()])
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40px",
      "color": "white"
    }
  }, [_vm._v("R. br")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Kompanija")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Broj porudžbina")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ff2be22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Report/OrderReport.vue
// module id = 455
// module chunks = 1